<template>
  <div class="social-wrap" :class="{ 'no-cursor': bindAccountNum === 1 && isBind }" @click="refreshBindInfo">
    <div class="logo-wrap">
      <span class="logo facebook"></span>
      <span class="name">Facebook</span>
    </div>
    <div class="account-name" :class="{ 'no-arr': bindAccountNum === 1 && isBind }">
      <template v-if="isBind">{{ isBind }}</template>
      <template v-else>{{ $t('web_unbind') }}</template>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import FetchBindInfo from '@/mixins/fetchBindInfo'
export default {
  name: 'AccountFacebook',
  mixins: [FetchBindInfo],
  data () {
    return {
      visible: false,
      userInfo: {},
      once_key: undefined
    }
  },
  computed: {
    ...mapGetters(['bindAccountNum']),
    ...mapState({
      bindInfo: state => state.bindInfo.facebook,
    }),
    isBind () {
      return this.bindInfo.name || this.bindInfo.email || ''
    }
  },
  methods: {
    ...mapMutations({
      setBindInfoItem: 'setBindInfoItem'
    }),
    refreshBindInfo () {
      if (!window.FB) return
      if (this.isBind) {
        if (this.bindAccountNum <= 1) return
        this.mixinsRefreshBindInfo('loginClick')
      } else {
        this.loginClick()
      }
      
    },
    loginClick () {
      if (!window.FB) return
      if (this.isBind) {
        if (this.bindAccountNum <= 1) return
        this.$dialog(
          {
            title: this.$t('web_tips_title'),
            text: this.$t('web_unbind_tips', { 0: 'Facebook' }),
            confirmTxt: this.$t('test_confirm'),
            cancelTxt: this.$t('test_cancel')
          },
          this.onFBLogin
        )
        this.$utils.log('pc_account_center', {
          action: 'unbind',
          method: this.$ENUM.SOCIAL_MAP.FACEBOOK
        })
      } else {
        this.$utils.log('pc_account_center', {
          action: 'bind',
          method: this.$ENUM.SOCIAL_MAP.FACEBOOK
        })
        this.onFBLogin()
      }
    },
    onFBLogin () {
      const _this = this
      // 检测FB登录状态
      window.FB.logout()
      window.FB.login(function(loginRes) {
        _this.$Spin.show()
        if (loginRes.status === 'connected') {
          // Logged into your webpage and Facebook.
          const authResponse = loginRes.authResponse
          window.FB.api('/me', function(profileRes) {
            if (!profileRes.id) {
              _this.$msg.success(_this.$t('web_bind_fail'))
              window.FB.logout()
              this.$Spin.hide()
              return
            }
            console.log('authResponse', authResponse, profileRes)
            _this.userInfo = {
              id: profileRes.id || '',
              name: profileRes.name,
              token: authResponse.accessToken,
              type: 'facebook',
              expire: authResponse.expiresIn
            }
            if (_this.isBind) {
              _this.unbind()
            } else {
              _this.bind()
            }
          })
        } else {
          _this.$msg.success(_this.$t('web_bind_fail'))
          _this.$Spin.hide()
        }
      }, { scope: 'public_profile, email' })
    },
    bind () {
      this.once_key = this.$utils.getTS()
      this.$Spin.show()
      this.$socket.push({
        params: {
          action: 'web_bind',
          userInfo: this.userInfo,
          once_key: this.once_key
        },
        cb: this.bindHandler
      })
    },
    bindHandler (resp) {
      if (resp.action !== 'web_bind' && resp.once_key !== this.once_key) return
      this.$Spin.hide()
      if (resp.code === 0) {
        this.setBindInfoItem({
            key: 'facebook',
            value: {
              name: this.userInfo.name
            }
          })
          this.$msg.success(this.$t('web_bind_ok'))
      } else if (resp.code === 1001) {
        // 绑定/解绑时当前 fpid 和微端 fpid 不一致
        this.$dialog(
          {
            text: this.$t('login_fail_2'),
            confirmTxt: this.$t('try_again')
          },
          () => window.location.reload()
        )
      } else {
        const msg = this.$t(`KGSDK_${resp.code}`) === `KGSDK_${resp.code}` ? this.$t('web_bind_fail') : this.$t(`KGSDK_${resp.code}`)
        this.$msg.success(msg)
      }
    },
    unbind () {
      this.once_key = this.$utils.getTS()
      this.$Spin.show()
      this.$socket.push({
        params: {
          action: 'web_unbind',
          userInfo: this.userInfo,
          once_key: this.once_key
        },
        cb: this.unbindHandler
      })
    },
    unbindHandler (resp) {
      if (resp.action !== 'web_unbind' && resp.once_key !== this.once_key) return
      this.$Spin.hide()
      if (resp.code === 0) {
        this.setBindInfoItem({
          key: 'facebook',
          value: {
            name: '',
            email: ''
          }
        })
        window.unbindClose()
        this.$msg.success(this.$t('web_tips_unbind'))
      } else if (resp.code === 1001) {
        // 绑定/解绑时当前 fpid 和微端 fpid 不一致
        this.$dialog(
          {
            text: this.$t('login_fail_2'),
            confirmTxt: this.$t('try_again')
          },
          () => window.location.reload()
        )
      } else {
        this.$msg.success(this.$t(`KGSDK_${resp.code}`))
      }
    }
  }
}
</script>

<style lang='less' scoped >
@import url('@/assets/styles/account.less');
</style>
